import type { SVGProps } from 'react';

export function PiggyBankIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.999 2A1 1 0 0 1 17 3v3.255l.026.018A7 7 0 0 1 19.23 8.81l.092.19h.676a2 2 0 0 1 1.995 1.85l.005.15v2a2 2 0 0 1-2 2h-.676l-.104.213a7 7 0 0 1-1.097 1.558l-.123.125V18.5a2.5 2.5 0 0 1-2.336 2.495L15.5 21c-1.16 0-2.135-.79-2.418-1.86l-.032-.141L9 19l-.05-.002-.032.141a2.5 2.5 0 0 1-2.254 1.856L6.5 21A2.5 2.5 0 0 1 4 18.5v-1.602l-.056-.055a7 7 0 0 1-1.576-7.085l.092-.256A7 7 0 0 1 8.999 5h2.196l4.25-2.832a1 1 0 0 1 .436-.161zM15 10a1 1 0 0 0-.993.883L14 11.01a1 1 0 0 0 1.993.117L16 11a1 1 0 0 0-1-1" />
    </svg>
  );
}
